import React, { FC } from 'react';
import { EmployeeEvent } from 'src/interfaces/api/Gaming';
import Card from 'src/components/Card';
import { Box } from '@material-ui/core';
import { HiLightningBolt as XpIcon } from '@react-icons/all-files/hi/HiLightningBolt';
import EventAvatar from './EventAvatar';
import moment from 'moment';

interface Props {
  event: EmployeeEvent;
}

const FeedEvent: FC<Props> = ({ event }) => {
  return (
    <Box p='18px !important' clone>
      <Card>
        <Box display='flex' alignItems='center'>
          <EventAvatar eventType={event.type} />
          <Box flexGrow={1} mx={1}>
            <Box fontWeight='bold' fontSize={13}>
              {event.title}
            </Box>
            <Box fontSize={13}>{event.description}</Box>
            <Box color='text.disabled' fontSize={11}>
              {moment(event.createdAt).format('DD MMM YYYY')}
            </Box>
          </Box>
          <Box color='primary.main' display='flex' alignItems='center'>
            {event.points} <XpIcon size={18} />
          </Box>
        </Box>
      </Card>
    </Box>
  );
};

export default FeedEvent;
